/**
 * PC 화면 껍데기 치수 (2026-09-23)
 *
 * 상단 바 높이를 MainLayout 이 혼자 들고 있었는데,
 * 화면 전체를 덮는 창(예: AS 달력)도 이 높이를 알아야 상단 바를 가리지 않는다.
 * 두 곳에 64 를 따로 적어 두면 한쪽만 고쳤을 때 어긋나므로 여기로 모은다.
 */
export const TOPBAR_H = 64;   // 상단 바 높이 (components/TopBar.js 의 bar.height 와 같아야 함)
export const SIDEBAR_W = 240; // 사이드바 너비
